import { useLayoutEffect, useRef } from "react";

import classnames from "classnames";
import { isPresent } from "neetocist";
import PropTypes from "prop-types";

import RightBlock from "./RightBlock";
import "./subheader.scss";

const SubHeader = ({
  className = "",
  leftActionBlock,
  rightActionBlock,
  "data-testid": dataTestid = "subheader",
}) => {
  const subheaderRef = useRef(null);

  useLayoutEffect(() => {
    const updateHeaderHeight = () => {
      if (!subheaderRef.current) return;
      const height = subheaderRef.current.offsetHeight;
      document.body.style.setProperty(
        "--neeto-molecules-effective-subheader-height",
        `${height}px`
      );
    };

    updateHeaderHeight();

    window.addEventListener("resize", updateHeaderHeight);

    return () => window.removeEventListener("resize", updateHeaderHeight);
  }, []);

  return (
    <div
      className={classnames(["neeto-molecules-subheader", className])}
      data-testid={isPresent(dataTestid) ? dataTestid : "subheader"}
      ref={subheaderRef}
    >
      <div
        className="neeto-molecules-subheader__left-wrapper"
        data-testid="subheader-left-wrapper"
      >
        {leftActionBlock && (
          <div
            className="neeto-molecules-subheader__left"
            data-testid="subheader-left"
          >
            {leftActionBlock}
          </div>
        )}
      </div>
      {rightActionBlock && (
        <div
          className="neeto-molecules-subheader__right"
          data-testid="subheader-right"
        >
          {rightActionBlock}
        </div>
      )}
    </div>
  );
};

SubHeader.RightBlock = RightBlock;

SubHeader.propTypes = {
  /**
   * To specify external classnames as overrides to the `SubHeader`.
   */
  className: PropTypes.string,
  /**
   * To specify the content to be rendered in the left side of the `SubHeader` section.
   */
  leftActionBlock: PropTypes.node,
  /**
   * To specify the content to be rendered in the right side of the `SubHeader` section.
   */
  rightActionBlock: PropTypes.node,
};

export default SubHeader;
